import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    // KATEGORIE

    postKategoria(nazwa) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/kategoria' + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
            data: {
                "nazwa": nazwa
            }
        });
    },

    getKategorie() {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/strona/kategorie' + AppConfig.V_LOG(),
        });
    },

    deleteKategoria(id) {
        return axios({
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/kategoria/' + id + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
        });
    },

    // STRONY

    postStrona(typ, tytul, tresc, aktywny, kategoria, pliki) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/wpis' + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
            data: {
                "typ": typ,
                "tytul": tytul,
                "tresc": tresc,
                "aktywny": aktywny,
                "kategoria": kategoria,
                "plikiRequest": pliki
            }
        });
    },

    putStrona(id, typ, tytul, tresc, aktywny, kategoria, pliki) {
        return axios({
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/wpis/' + id + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
            data: {
                "id": id,
                "typ": typ,
                "tytul": tytul,
                "tresc": tresc,
                "aktywny": aktywny,
                "kategoria": kategoria,
                "plikiRequest": pliki
            }
        });
    },

    getStrony() {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/wpis?size=9999' + AppConfig.V_LOG_SECOND_PARAM(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
        });
    },

    getStronaById(id, typ) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/strona/wpis/' + id + AppConfig.V_LOG(),
        });
    },

    getStronyByTyp(typ, aktywny) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/strona/wpis/byTypAndAktywny/' + typ + '/' + aktywny + AppConfig.V_LOG(),
        });
    },

    getEventy(idKl) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            auth: {
                username: JSON.parse(sessionStorage.getItem('loggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('loggedIn')).pass
            },
            url: URL + 'client/api/auth/event/klient/' + idKl + AppConfig.V_LOG(),
        });
    },

    getNews(size) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/strona/wpisy/newsy?size=' + size + AppConfig.V_LOG_SECOND_PARAM(),
        });
    },

    getSlider() {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/strona/wpisy/slider' + AppConfig.V_LOG(),
        });
    },

    deleteStrona(id) {
        return axios({
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/wpis/' + id + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
        });
    },

    deletePlikAdmin(id) {
        return axios({
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/strona/wpis/plik/' + id + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
        });
    },

    getDostep(login, pass) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: AppConfig.HOST_EBUS() + 'api/dostep' + AppConfig.V_LOG(),
            auth: {
                username: login,
                password: pass
            },
            data: {
                "fcmToken": JSON.parse(localStorage.getItem('fcm-token')),
                "login": login,
                "pass": pass
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminService.js